import React, { useEffect } from 'react';
import NodePanel from '../Sos2/NodePanel';   // REUSED unchanged (the unit detail pane)
import '../Sos2/grades.css';                 // bundle the grade/axis styling NodePanel expects
// NOTE: NodePanel also uses Bootstrap 5 classes. The host page must load Bootstrap
// (the article page will). The demo page loads it via CDN, matching the icicle page.

// The pane content shown "beyond the app" — an overlay modal that can grow past the
// thin strip's footprint. Reuses the existing NodePanel detail body.
//
// Read-only for viewers: chat is disabled by passing onDiscussAxis={null} (NodePanel
// already hides the discuss chips when it is null). Generate/repair is disabled via
// readOnly — see WIRE_UP.md for the small, backward-compatible NodePanel prop. Until
// that prop lands, the /assistant/path-execution endpoint still blocks non-owners
// server-side (401/403), so a viewer cannot actually generate anything.
export default function DetailModal({ node, peers, movieHash, script = null, canGenerate, onClose, showAllScores = false }) {
  useEffect(() => {
    const onKey = (e) => { if (e.key === 'Escape') onClose(); };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onClose]);

  return (
    <div className="lrs-modal-overlay" onClick={onClose}>
      <div
        className="lrs-modal"
        role="dialog"
        aria-modal="true"
        aria-label={node?.title || node?.displayLabel || 'Scene detail'}
        onClick={(e) => e.stopPropagation()}
      >
        <button type="button" className="lrs-modal-close" aria-label="Close" onClick={onClose}>×</button>
        <div className="lrs-modal-body">
          <NodePanel
            node={node}
            peers={peers}
            script={script}               /* grain nouns (scene/beat) come from the script row, as in Icicle */
            /* Viewers get an EMPTY hash → NodePanel's canWrite is false, so the
               "Write this for me" button and feedback POSTs never render (no failing
               call). Owners get the real hash and full function. Zero NodePanel edits. */
            movieHash={canGenerate ? movieHash : ''}
            movieId={null}                 /* internal id stays out of the front-end */
            /* Craft Read by HASH, for viewers as well as owners. Separate from movieHash above,
               which is blanked for viewers to keep the write affordance off — see NodePanel. The
               /lrsnapshot/craftread route gates this hash exactly as /lrsnapshot/data gates the
               payload the snapshot is already showing. */
            craftHash={movieHash}
            layout="twocol"
            onDiscussAxis={null}           /* chat off in the snapshot */
            readOnly={!canGenerate}        /* viewer: show generate DISABLED as a teaser (NodePanel readOnly prop) */
            showAllScoresDefault={showAllScores}  /* article-helper snapshots can default the not-owed reveal ON */
          />
        </div>
      </div>
    </div>
  );
}
